import { defineMessages } from 'react-intl';

export default defineMessages({
    valuablesModalTitle: {
        id: 'quoteandbind.ngh.views.NamedItems.valuablesModalTitle',
        defaultMessage: 'Named Items - Other'
    },
    valuableType: {
        id: 'quoteandbind.ngh.views.NamedItems.valuableType',
        defaultMessage: 'Item type'
    },
    valuablesModalInfo1: {
        id: 'quoteandbind.ngh.views.otherItems.valuablesModalInfo1',
        defaultMessage: 'As well as what we consider to be valuables, we also need to know about other items that you plan to take away from the home that are above a certain value.'
    },
    valuablesModalAdditionalInfo1: {
        id: 'quoteandbind.ngh.views.otherItems.valuablesModalAdditionalInfo1',
        defaultMessage: 'Think about any items that you often take away from the home that individually would cost more than '
    },
    valuablesModalAdditionalInfo2: {
        id: 'quoteandbind.ngh.views.otherItems.valuablesModalAdditionalInfo2',
        defaultMessage: ' to replace. This includes things like sporting equipment, mobility aids, prosthesis and guns. If you would like these to be covered by your policy, add them in this section.'
    },
    ValuableItemDescription: {
        id: 'quoteandbind.ngh.views.otherItems.ValuableItemDescription',
        defaultMessage: 'Please provide as much detail as possible here including the make and model of the item you wish to insure. An accurate and specific physical description helps us deal with claims promptly.'
    },
    singleArticleLimitValidationMessage: {
        id: 'quoteandbind.ngh.views.otherItems.singleArticleLimitValidationMessage',
        defaultMessage: 'Only items valued more than { limit } need to be declared'
    },
    serialNumberDescription: {
        id: 'quoteandbind.ngh.views.otherItems.serialNumberDescription',
        defaultMessage: 'Please provide the serial number of the gun you wish to insure'
    },
    insideHomeOnly: {
        id: 'quoteandbind.ngh.views.valuables.otherItems.insideHomeOnly',
        defaultMessage: 'Inside the home only'
    },
    bothInsideOutsideHome: {
        id: 'quoteandbind.ngh.views.valuables.otherItems.bothInsideOutsideHome',
        defaultMessage: 'Both inside and outside the home'
    },
    valuableReplacementCostTootltip: {
        id: 'quoteandbind.ngh.views.itemsOutside.valuableReplacementCost.tooltip',
        defaultMessage: 'Remember this is the cost to replace the item new rather than its current value'
    }
});
